import { Button, Row, Tag, Typography } from "antd";
import styled, { css } from "styled-components";

export const Wrapper = styled.div<{
  $isHighlighted: boolean;
}>`
  width: 368px;
  padding: 24px;
  border-radius: 16px;

  ${(props) =>
    props.$isHighlighted &&
    css`
      border: 1px solid ${"#1677ff"};
    `}
`;

export const TitleRow = styled(Row)`
  margin-bottom: 16px;

  .title {
    margin: 0;
  }

  .title-last-child {
    color: ${"#8c8c8c"};
    padding-left: 4px;
    margin-top: 0;
  }
`;

export const CardBody = styled.div`
  .title-cart {
    font-weight: 500;
  }

  .row-not-last-child {
    margin-bottom: 4px;
  }
`;

export const StyledTag = styled(Tag)<{ $textColor: string }>`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 77px;
  height: 16px;

  color: ${(props) => props.$textColor};
`;

export const StyledText = styled(Typography.Text)<{
  $backgroundColor?: string;
}>`
  height: 24px;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 4px;
  line-height: 18px;
  background-color: ${(props) => props.$backgroundColor};
`;

export const ExtraBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  a {
    color: ${"#1677ff"};
  }
  
  .button {
    width: fit-content;
  }

  > *:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const DocsButton = styled(Button)`
  padding: 0;
  height: 24px;
`;
